import React, { useState } from 'react';
import { FDBodyText, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import OnboardingAddItemButton
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ExpensesDetail/OnboardingAddItemButton';
import fr from 'facet-rest';
import {
  CustomGoalsSection,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSelection/components/CustomGoalSection/CustomGoalSection';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { useSnackbarContext } from 'Context/SnackbarContext';

function GoalSelectionLayout() {
  const { resource, onSubmit: onSubmitMetaForm } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [customGoals, setCustomGoals] = useState(resource?.attr('customOutcomes')?.resources()?.list() || []);

  const handleDeleteCustomGoal = async (customOutcome) => {
    try {
      await customOutcome.delete();
      resource.attr('customOutcomes').resources().removeItem(customOutcome.id());
      setCustomGoals(resource?.attr('customOutcomes')?.resources()?.list() || []);
    } catch (e) {
      displayErrorMessageWithChecks(e, displayErrorMessage, 'Failed to delete custom goal');
    }
  };


  const AddCustomGoalButton = resource.withRelationship(fr.relationships.addCustomGoal.name,
    (rel) => {
      const handleAddCustomGoal = async () => {
        try {
          const collection = await rel.getRelated();
          const [newCustomGoal] = await collection.create().submit();
          setCustomGoals((prevGoals) => [...prevGoals, newCustomGoal]);
        } catch (e) {
          displayErrorMessageWithChecks(e, displayErrorMessage, 'Failed to add custom goal');
        }
      };
      return (
        <FDStack direction={'column'} spacing={2} alignItems={'center'}>
          <OnboardingAddItemButton relationship={rel} onAdd={() => handleAddCustomGoal(rel)} />
          {customGoals.length === 0 && <FDBodyText color={'textDisabled'} value={'e.g., a gourmet pickle truck, a dream vacation, or a treehouse village.'} align={'center'} />}
        </FDStack>
      );
    },
    () => null);

  return (
    <FDStack direction={'column'} spacing={4} alignItems={'center'} width={'100%'}>
      <FDStack direction={'column'} spacing={2} alignItems={'center'} width={'100%'} maxWidth={425}>
        <MetaControlField attr={'title'} simpleRootStyle />
        <MetaControlField attr={'subtitle'} simpleRootStyle />
      </FDStack>
      <FDStack direction={'column'} spacing={6} alignItems={'center'} width={'100%'} maxWidth={425}>
        <MetaControlField attr={'popularOutcomes'} allowedMetaProps={['description']} />
        <MetaControlField attr={'uniqueOutcomes'} allowedMetaProps={['description']} />
        <CustomGoalsSection resources={customGoals} onDelete={handleDeleteCustomGoal} />
        {AddCustomGoalButton}
      </FDStack>
      <SurveyStepFooter onSubmit={onSubmitMetaForm} />
    </FDStack>
  );
}

export default GoalSelectionLayout;
